// extracted by mini-css-extract-plugin
export var userNotificationsSidebar = "user-notifications__sidebar_c0_5Mz4ewhtA4eq42HT0";
export var userNotificationsSidebarSection = "user-notifications__sidebar-section_JijhAfD8e3U67hZXyV3W";
export var userNotificationsSidebarSectionGrown = "user-notifications__sidebar-section_grown_L46PPSokTEiiUDlfI3ji";
export var userNotificationsTopic = "user-notifications__topic_yHDtYKDF42ssyKuM4J66";